import * as m from 'mithril';
import AppContext from '../context/AppContext';

import { SubFsm } from 'little-fsm';
import TravellerFormPage from '../pages/travellerinfo/TravellerFormPage';
import { TentativeBookingReviewFsmScheme } from '../states/review/TentativeBookingReviewFsmScheme';
import TentativeBookingReviewPage from '../pages/review/TentativeBookingReviewPage';
import { TravellerDTO } from '../apiclient/ApiDtos';
import { ApiService } from '../ApiService';

export function buildReviewPresenter(
    appContext: AppContext, 
    apiService: ApiService, 
    subFsm:SubFsm<TentativeBookingReviewFsmScheme>): {
        render:(completionCommandInterceptor?:()=>void) => m.Vnode
    } {
    
    let messageProvider = appContext.getMessageProvider();

    subFsm.setEnterEffect('updating', c => {
        let travellerInfo = c.travellerInfo;
        let tenativeBookingId = c.tentativeBooking.id;
        apiService.updateTentativeBooking(tenativeBookingId, travellerInfo).then(result => {
            console.log("Tentative Booking result", result);
            if(result.right){
                subFsm.processEvent('update_succeeded', {tentativeBooking: result.right})
            }
        });
    })

    return {
        render(completionCommandInterceptor?:()=>void) {
            let context = subFsm.getCurrentContext(); 
            let substate = subFsm.getCurrentSubState();   
            
            if(substate == 'showing_review' || substate == 'back_navigation_confirming') {
                return m(TentativeBookingReviewPage, {
                    appContext: appContext,
                    messageProvider: appContext.getMessageProvider(),
                    tentativeBooking: context.tentativeBooking,
                    onTravellerInfoUpdateRequested: () => {
                        subFsm.processEvent('update_initiated', {})
                    },
                    onReviewCompleted: () => {
                        if (!completionCommandInterceptor) {
                            subFsm.processEvent('review_completed', {});
                        } else {
                            completionCommandInterceptor();
                        }                     
                    },
                    isBacktracking: substate == 'back_navigation_confirming',
                    onBacktrackRequested: () => {
                        subFsm.processEvent('back', {});
                    },
                    onBacktrackConfirmed: () => {
                        subFsm.processEvent('back_confirmed', {});
                    },
                    onBacktrackCancelled: () => {
                        subFsm.processEvent('back_cancelled', {});
                    }
                });
            } else {
                let tenativeBooking = context.tentativeBooking;

                return m(TravellerFormPage, {
                    appContext: appContext,
                    messageProvider: appContext.getMessageProvider(),
                    tripCustomization: context.tripCustomizationContext.tripCustomization!,
                    prefilledTravellerInfo: tenativeBooking.traveller,      
                    isBacktracking: false,  
                    isEditing: true,
                    isSubmitting: substate == 'updating',
                    onBacktrack: () => {
                        subFsm.processEvent('back', {});
                    },         
                    onBacktrackConfirmed: () => {
                        subFsm.processEvent('back_confirmed', {});
                    },
                    onBacktrackCancelled: () => {
                        subFsm.processEvent('back_cancelled', {});
                    },
                    onSubmit: (travellerInfo: TravellerDTO) => {                        
                        console.log("Traveller Form submit", travellerInfo);
                        subFsm.processEvent('update_submitted', {travellerInfo : travellerInfo});
                    },
                });
            }
        }
    }
}